import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseCreatePrivateCompanyLeadSpecialFeeProps {
  privateCompanyLeadId?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useCreatePrivateCompanyLeadSpecialFee = ({
  privateCompanyLeadId,
  onSuccess,
  onError,
}: UseCreatePrivateCompanyLeadSpecialFeeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPrivateCompanyLeadSpecialFee'],
    mutationFn: async (data: { value: string; type: string; fee_template_id: string; execution_priority?: number }) => {
      const private_company_lead = {
        fee_rule_attributes: {
          special_entries_attributes: [
            {
              target_id: data.value === 'all' ? null : data.value,
              target_type: data.type,
              fee_template_id: data.fee_template_id,
              execution_priority: data.execution_priority,
            },
          ],
        },
      }

      await privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
